import { render, staticRenderFns } from "./OptionPrixCampField.vue?vue&type=template&id=6445478c&scoped=true"
import script from "./OptionPrixCampField.vue?vue&type=script&lang=ts"
export * from "./OptionPrixCampField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6445478c",
  null
  
)

export default component.exports